import InlineSVG from 'svg-inline-react';

import snowflakeSvg from 'public/snowflake.svg';

import styles from './styles.module.scss';

export const RefrigerationItem = () => (
  <div className={styles.refigerationRow}>
    <div className={styles.svgContainer}>
      <InlineSVG className={styles.svgWrapper} src={snowflakeSvg} />
    </div>
    <div className={styles.secondaryTitle}>{'Refrigerate Upon Delivery'}</div>
  </div>
);
